import React, { useEffect, useState, useRef } from 'react';
import { useForm } from 'react-hook-form';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import { useUser } from '../hooks/useUser.jsx';
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import '../styles/Login.css';
import { ErrorMessage } from '../components/commons/ErrorMessage.jsx';
import ReCAPTCHA from "react-google-recaptcha";
import { TextFieldRequired } from '../components/commons/TextFieldRequired.jsx';
import colors from '../theme/colors';
import { styled } from '@mui/system';




const StyledContainer = styled(Container)`
  /* Estilos para el contenedor */
  &.container {
    min-height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

const StyledLoginContainer = styled(Grid)`
    /* Estilos para el contenedor de inicio de sesión */
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
    border-radius: 1.5rem;
    margin: 1rem;
    background-color: ${colors.textMain};
`;

const StyledSignIn = styled(Grid)`
    padding: 3rem;
    display: flex;
    align-self: stretch;
    text-align: center;
    align-items: center;
    justify-content: center;
    color: ${colors.textMain};
    background: -webkit-linear-gradient(to right, ${colors.primary}, ${colors.primaryDegradado});
    background: linear-gradient(to right, ${colors.primary}, ${colors.primaryDegradado});
`;




export function Login() {
    const { login, isLogged, loginError, errorType, getURLs } = useUser();
    const navigate = useNavigate();
    const { t, i18n } = useTranslation()
    const [openDialogError, setOpenDialogError] = useState(false);
    const [usuariosURL, setUsuariosURL] = useState();
    const recaptchaRef = useRef(null);
    const [fallos, setFallos] = useState(0);

    const {
        //Maneja los campos del form y sus estados
        control,
        //Maneja la presentacion del formulario
        handleSubmit,
    } = useForm();

    useEffect(() => {
        if (isLogged) {
            localStorage.removeItem("UserLogInErrorCount");
            navigate('/MisCuestionarios')
        }
        var urlPromise = getURLs()
            .then((x) => {
                setUsuariosURL(x.usuario);
            });
        setOpenDialogError(loginError);
        if (localStorage.getItem("UserLogInErrorCount") != null && localStorage.getItem("UserLogInErrorCount") != fallos) {
            setFallos(parseInt(localStorage.getItem("UserLogInErrorCount")));
        }
    }, [isLogged, navigate, loginError])

    const handleClose = () => {
        setOpenDialogError(false);
    }

    function handleRecaptcha() {
        if (recaptchaRef.current.getValue()) {

        }
    }


    const onSubmit = (data) => {
        if (fallos < 3 || recaptchaRef.current.getValue())
            login(data.username, data.password)
        if (!isLogged) {
            localStorage.setItem("UserLogInErrorCount", fallos + 1);
            if (fallos > 3)
                recaptchaRef.current.reset();
        }
    };


    return (

        <StyledContainer className='container'>
            <Typography variant="h1" display={"none"}></Typography>
            <StyledLoginContainer
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
            >
                <StyledSignIn item xs={12} lg={6}>
                    <Stack spacing={2} alignItems={"center"}>
                        <Typography variant="h2" color={colors.textMain} fontWeight={'bold'}>
                            {t('login.saludoPYME')}
                        </Typography>
                        <Typography variant="parrafoLight" style={{ display: 'block' }}>
                            {t('login.textoPYME')}
                        </Typography>
                        {usuariosURL &&
                            <Button variant="outlined" href={usuariosURL.registro} target='_blank' sx={{ width: "50%" }}>
                                {t('login.registrarse')}
                            </Button>
                        }
                    </Stack>
                </StyledSignIn>
                <Grid item xs={12} lg={6}>
                    <form className='form' onSubmit={handleSubmit(onSubmit)}>
                        <Stack spacing={2} padding={"3em"}>
                            <Box>
                                <Typography variant="h2" textAlign={"center"} fontWeight={'bold'} color={colors.primary}>
                                    {t('login.titulo')}
                                </Typography>
                            </Box>
                            <TextFieldRequired
                                control={control}
                                label={t("login.labelUsuario")}
                                name="username"
                            />
                            <TextFieldRequired
                                control={control}
                                label={t("login.labelContrasenia")}
                                name={"password"}
                                type='password'
                            />
                            {usuariosURL &&
                                <Link href={usuariosURL.olvidoPassword} target="_blank" style={{ paddingTop: '2em', margin: '0 auto' }}>
                                    {t('login.linkContrasenyaOlvidada')}
                                </Link>
                            }
                            {fallos >= 3 &&
                                <Box style={{ margin: '0 auto', paddingTop: '2em' }}>
                                    <ReCAPTCHA
                                        ref={recaptchaRef}
                                        sitekey={process.env.REACT_APP_RECAPTCHA_API_KEY}
                                        onChange={handleRecaptcha}
                                    />
                                </Box>
                            }
                            <Button
                                data-callback='onSubmit' data-action='submit' variant="contained" type="submit" className='buttonAcceder'>{t('login.botonAcceder')}</Button>
                        </Stack>
                    </form>
                </Grid>
                {openDialogError &&
                    <ErrorMessage showDialogError={openDialogError} errorDialogTitle={"login.errorDialogTitle"} errorType={"login." + errorType} handleClose={handleClose} />
                }
            </StyledLoginContainer>
        </StyledContainer >
    )
}